import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { HomeComponent } from './home/home.component';
import { HsscstudentComponent } from './hsscstudent/hsscstudent.component';
import { LandingComponent } from './landing/landing.component';
import { LoginComponent } from './login/login.component';
import { PrintDataComponent } from './print-data/print-data.component';
import { StudNewComponent } from './stud-new/stud-new.component';

const routes: Routes = [
  {path:'home', component:HomeComponent},
  {path:'sscstudents', component:StudNewComponent },
  {path:'hsscstudents', component:HsscstudentComponent },
  {path:'login', component:LoginComponent},
  {path:'result', component:PrintDataComponent },
  {path:'', component:LandingComponent },
  {path:'change-password', component:ChangepasswordComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    
      useHash: true
    
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
